/**
 * todo this model is used by the LSS Table. it will require updates when the LSS Table backend requirements are
 * implemented.
 *
 * it should also be noted that this does model not work for DSS Table, where there are 1 to many Users per DSS
 */
export interface LocationAndContact {
  organizationId?: number;

  countryId?: number;
  countryName?: string;

  // todo these should be User objects
  user1?: any;
  user2?: any;

  /* todo */
  lastUpdated?: string | number | Date;
  nextUpdateDue?: string | number | Date;

  ownSurvey?: boolean;
}
